// extracted by mini-css-extract-plugin
module.exports = {"wfvijsb":"wfvijsb"};